export function accordion() {
    const accordion = $(".accordion");
    const expander = accordion.find(".dropdown-header");
    const expandBtn = accordion.find(".expand-btn");

    function toggleContent(el) {
        const dropdown = el.parents(".dropdown");
        // dropdown.siblings(".dropdown").removeClass("active");
        dropdown.toggleClass("active");
    }

    expander.on("click", function () {
        toggleContent($(this));
    });

    expandBtn.on("click", function () {
        toggleContent($(this));
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/accordion.js